module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table"
  }, [_c('ui-title', {
    attrs: {
      "icon": "apps"
    }
  }, [_vm._v("Table")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "mdl-spinner mdl-js-spinner is-active"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h2', [_vm._v("Lorem ipsum")]), _vm._v(" "), _c('p', [_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Saepe deleniti, mollitia, accusantium atque suscipit officiis cupiditate doloremque vitae magni ducimus eaque maxime? Aut dicta culpa eligendi voluptatem quaerat iure nesciunt.")]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-responsive-table-box"
  }, [_c('table', {
    staticClass: "mdl-data-table mdl-js-data-table mdl-data-table--selectable mdl-shadow--2dp"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Material")]), _vm._v(" "), _c('th', [_vm._v("Quantity")]), _vm._v(" "), _c('th', [_vm._v("Unit price")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Acrylic (Transparent)")]), _vm._v(" "), _c('td', [_vm._v("25")]), _vm._v(" "), _c('td', [_vm._v("$2.90")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Plywood (Birch)")]), _vm._v(" "), _c('td', [_vm._v("50")]), _vm._v(" "), _c('td', [_vm._v("$1.25")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "mdl-data-table__cell--non-numeric"
  }, [_vm._v("Laminate (Gold on Blue)")]), _vm._v(" "), _c('td', {
    staticClass: "hello"
  }, [_vm._v("10")]), _vm._v(" "), _c('td', [_vm._v("$2.35")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-grid mdl-grid-negative"
  }, [_c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-cell--order-2-phone"
  }, [_c('div', {
    staticClass: "demo-card-wide mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Welcome 1")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Mauris sagittis pellentesque lacus eleifend lacinia...\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
  }, [_vm._v("\n            Get Started\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__menu"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-cell mdl-cell--6-col mdl-cell--4-col-tablet mdl-cell--4-col-phone mdl-cell--order-1-phone"
  }, [_c('div', {
    staticClass: "demo-card-wide mdl-card mdl-shadow--2dp"
  }, [_c('div', {
    staticClass: "mdl-card__title"
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("Welcome 2")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__supporting-text"
  }, [_vm._v("\n          Lorem ipsum dolor sit amet, consectetur adipiscing elit.\n          Mauris sagittis pellentesque lacus eleifend lacinia...\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__actions mdl-card--border"
  }, [_c('a', {
    staticClass: "mdl-button mdl-button--colored mdl-js-button mdl-js-ripple-effect"
  }, [_vm._v("\n            Get Started\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "mdl-card__menu"
  }, [_c('button', {
    staticClass: "mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("share")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c99817a8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Table.vue
// module id = 286
// module chunks = 2